import React, { useRef, useState } from "react";
import { getOGimage, getUrl } from "../../utils/getUrl";
import Head from "next/head";
import {
  Configure,
  InstantSearch,
  usePagination,
  // getServerState,
  InstantSearchSSRProvider,
  useHits,
} from "react-instantsearch-hooks-web";
import { history } from "instantsearch.js/es/lib/routers";
// import {InstantSearch} from 'react-instantsearch-core'
import { getServerState } from "react-instantsearch-hooks-server";
import { renderToString } from "react-dom/server";
import algoliasearch from "algoliasearch/lite";
import { useRouter } from "next/router";

import PropertyTownHit from "../../components/search/PlacePropertyHit/PropertyTownHit";

const algoliaClient = algoliasearch(
  process.env.NEXT_PUBLIC_SEARCH_APP_ID,
  process.env.NEXT_PUBLIC_SEARCH_API_KEY
);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    // console.log(requests);
    if (requests.every(({ params }) => params.query)) {
      // console.log(requests);
      //   return Promise.resolve({
      //     results: requests.map(() => ({
      //       towns: [],
      //       nbtowns: 0,
      //       nbPages: 0,
      //       page: 0,
      //       processingTimeMS: 0,
      //       townsPerPage: 0,
      //       exhaustiveNbtowns: false,
      //       query: "",
      //       params: "",
      //     })),
      //   });
    }
    return algoliaClient.search(requests);
  },
};

const CustomPaginationT = ({ currentPage, setCurrentPage }) => {
  const { currentRefinement, nbPages, refine } = usePagination();

  return (
    <div>
      {new Array(nbPages).fill(null).map((_, index) => (
        <button
          key={index}
          onClick={() => {
            refine(index);
            setCurrentPage(index);
          }}
        >
          {index + 1}
        </button>
      ))}
    </div>
  );
};

function CustomPagination() {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
  } = usePagination();
  const firstPageIndex = 0;
  const previousPageIndex = currentRefinement - 1;
  const nextPageIndex = currentRefinement + 1;
  const lastPageIndex = nbPages - 1;

  return (
    <ul className=" flex flex-row space-x-3 ">
      {/* <PaginationItem
        isDisabled={isFirstPage}
        href={createURL(firstPageIndex)}
        onClick={() => {refine(firstPageIndex)
          // setCurrentPage(firstPageIndex);
        }}
      >
        First
      </PaginationItem> */}
      {/* <PaginationItem
        isDisabled={isFirstPage}
        href={createURL(previousPageIndex)}
        onClick={() => {refine(previousPageIndex)
          
        }}
      >
        Previous
      </PaginationItem> */}
      {pages.map((page) => {
        const label = page + 1;

        return (
          <PaginationItem
            key={page}
            isDisabled={false}
            aria-label={`Page ${label}`}
            href={createURL(page)}
            onClick={() => {
              refine(page);
              // setCurrentPage(page);
            }}
          >
            {label}
          </PaginationItem>
        );
      })}
      {/* <PaginationItem
        isDisabled={isLastPage}
        href={createURL(nextPageIndex)}
        onClick={() => {refine(nextPageIndex)
          // setCurrentPage(nextPageIndex);
        }}
      >
        Next
      </PaginationItem> */}
      {/* <PaginationItem
        isDisabled={isLastPage}
        href={createURL(lastPageIndex)}
        onClick={() => {refine(lastPageIndex)
          // setCurrentPage(lastPageIndex);
        }}
      >
        Last
      </PaginationItem> */}
    </ul>
  );
}

function PaginationItem({ isDisabled, href, onClick, ...props }) {
  if (isDisabled) {
    return (
      <li>
        <span {...props} />
      </li>
    );
  }

  return (
    <li className="  w-4">
      <a
        href={href}
        rel="noindex"
        className={" " + (isDisabled ? "" : " ")}
        onClick={(event) => {
          if (isModifierClick(event)) {
            return;
          }

          event.preventDefault();

          onClick(event);
        }}
        {...props}
      />
    </li>
  );
}

function isModifierClick(event) {
  const isMiddleClick = event.button === 1;

  return Boolean(
    isMiddleClick ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey
  );
}

function Index({ serverState }) {
  //  console.log(serverUrl)
  const serverUrl = getUrl() + `/homes`;

  const router = useRouter();

  const [loadingProperty, setLoadingProperty] = useState(null);

  //console.log(serverState);
  const props =
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? serverState?.initialResults?.properties?.results[0]?.hits
      : serverState?.initialResults?.staging_PROPERTIES?.results[0]?.hits;
  // console.log(props);

  const [currentPage, setCurrentPage] = useState(0);

  function PropertyHitImage({
    loadingProperty,
    setLoadingProperty,
    props,
    router,
    selectedProperty,
    selectedPropertyId,
  }) {
    const { hits, results, sendEvent } = useHits();
    //  console.log(router)
    return (
      <div className=" grid min-h-[60vh] grid-cols-1 gap-y-8 overscroll-y-auto px-0 pb-10 md:grid-cols-2 md:gap-10 lg:grid-cols-3 lg:gap-5 lg:px-0 ">
        {hits?.map((hit) => {
          return (
            <PropertyTownHit
              // sendEvent={sendEvent}
              key={hit.objectID}
              hit={hit}
              loadingProperty={loadingProperty}
              setLoadingProperty={setLoadingProperty}
              reff={(el) => (selectedProperty.current[hit.objectID] = el)}
              selectedPropertyId={selectedPropertyId}
            />
          );
        })}
      </div>
    );
  }

  const breadSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "Webpage",
          "@id": `${getUrl()}`,
          name: "Zote",
          url: `${getUrl()}`,
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "WebPage",
          "@id": `${getUrl()}/homes`,
          name: `Find available houses for rent and sale in Nairobi`,
          url: `${getUrl()}/homes`,
        },
      },
    ],
  };

  const selectedProperty = useRef({});
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);

  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <title>{`Find available houses for rent and sale in Nairobi`}</title>
        <meta
          name="description"
          content={`Discover your dream home from a wide range of rentals and houses in your town. Browse the largest selection of apartments, studios, villas and more
          | Zote`}
        />
        <meta
          name="og:title"
          content={`Find available houses for rent and sale in Nairobi`}
        />

        <meta
          name="og:description"
          content={`Discover your dream home from a wide range of rentals and houses in your town. Browse the largest selection of apartments, studios, villas and more
          | Zote`}
        />

        <meta property="og:url" content={`${getUrl()}/homes`} />
        <meta name="og:image" content={`${getOGimage()}`} />
        <link rel="canonical" href={`${getUrl()}/homes`} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadSchema) }}
        />
      </Head>

      <main className="flex flex-col space-y-3 px-5 py-8 lg:px-32 lg:py-16">
        <InstantSearchSSRProvider {...serverState}>
          <InstantSearch
            key={"homes-index"}
            searchClient={searchClient}
            // initialUiState={serverState}
            indexName={process.env.NEXT_PUBLIC_PROPERTIES_INDEX}
            routing={{
              router: history({
                getLocation: () =>
                  typeof window === "undefined"
                    ? new URL(serverUrl)
                    : window.location,
              }),
            }}
          >
            <>
              <Configure
                hitsPerPage={
                  process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? 30 : 5
                }
                maxValuesPerFacet={100}
                page={currentPage}
              />
              <h1 className=" mb-3 text-xl font-medium lg:text-2xl">
                Find available houses for rent and sale in Nairobi
              </h1>
              <PropertyHitImage
                loadingProperty={loadingProperty}
                setLoadingProperty={setLoadingProperty}
                props={props}
                router={router}
                selectedProperty={selectedProperty}
                selectedPropertyId={selectedPropertyId}
              />
              <div className=" ">
                <CustomPagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </>
          </InstantSearch>
        </InstantSearchSSRProvider>
      </main>
    </>
  );
}

export async function getStaticProps({ params }) {
  const serverUrl = getUrl() + `/homes`;

  const serverState = await getServerState(<Index serverUrl={serverUrl} />, {
    renderToString,
  });

  let props =
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? serverState?.initialResults?.properties?.results[0]?.hits
      : serverState?.initialResults?.staging_PROPERTIES?.results[0]?.hits;

  // Reduce the objects in the props array
  props = props.map((item) => ({
    propertyTown: item.propertyTown,
    objectID: item.objectID,
    propertyCounty: item.propertyCounty,
    images: item.images,
    listingType: item.listingType,
    monthlyRent: item.monthlyRent ?? null,
    price: item.price ?? null,
    noOfBedrooms: item.noOfBedrooms,
    propertyType: item.propertyType,
    propertyArea: item.propertyArea,
    slugShort: item.slugShort,
  }));

  if (process.env.NEXT_PUBLIC_VERCEL_ENV === "production") {
    serverState.initialResults.properties.results[0].hits = props;
  } else {
    serverState.initialResults.staging_PROPERTIES.results[0].hits = props;
  }

  return {
    props: {
      serverState,
      serverUrl,
    },
    revalidate: 10080,
  };
}

export default Index;
